import { useUserContext } from 'common/contexts/UserContext';
import { Routes } from 'constants/pages';
import { Header } from 'layouts/SignUpTemplate/components/Header';
import * as React from 'react';
import { Link } from 'react-router-dom';

export const AlreadyCreated: React.FC = () => {
  const { user } = useUserContext();
  return (
    <div className="w-full max-w-[520px] space-y-8 text-center">
      <Header
        header={`Welcome to ${user?.company?.name}!`}
        subHeader={
          <>
            Your company exists! To make changes, please{' '}
            <a href="mailto:contact@bluecargo.io" className="text-blue-900">
              contact us
            </a>
            .
          </>
        }
      />
      <Link to={Routes.Home} className="block text-blue-900 underline">
        Get Started
      </Link>
    </div>
  );
};
